// Scroll-reveal: adds .rv to candidate elements, then .in when they
// enter the viewport. Elements are only hidden *after* JS runs, so a
// JS failure never blanks the page. Stagger is computed per-parent.
let io = null;

const SELECTOR = [
  ".section",
  ".proj",
  ".role-block",
  ".skill",
  ".cert-cell",
  ".channel",
  ".quote-slab",
  ".foot-slab",
].join(", ");

export function initReveals() {
  if (typeof window === "undefined" || typeof document === "undefined") return;

  const els = document.querySelectorAll(SELECTOR);
  if (!els.length) return;

  const reduced =
    window.matchMedia &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  if (reduced || !("IntersectionObserver" in window)) {
    els.forEach((el) => el.classList.add("rv", "in"));
    return;
  }

  if (!io) {
    io = new IntersectionObserver(
      (entries) => {
        entries.forEach((en) => {
          if (en.isIntersecting) {
            en.target.classList.add("in");
            io.unobserve(en.target);
          }
        });
      },
      { rootMargin: "0px 0px -7% 0px", threshold: 0.05 }
    );
  }

  els.forEach((el) => {
    if (el.classList.contains("rv")) return; // already wired
    // stagger by position among siblings (rows in a list cascade)
    const parent = el.parentNode;
    const idx = parent
      ? Array.prototype.indexOf.call(parent.children, el)
      : 0;
    el.style.transitionDelay = Math.min(idx * 55, 380) + "ms";
    el.classList.add("rv");
    io.observe(el);
  });
}
